<asw-pet-input-pres
  *ngIf="isReadtToShow"
  [petTypeList]="petTypeList"
  [cageTypeList]="cageTypeList"
  [cageSizeExplainList]="cageSizeExplainList"
  [cageSizeList]="cageSizeList"
  [petInputInformation]="petInputInformation"
></asw-pet-input-pres>
